/**
 * A person's name in parts: first and last, with the full name for the
 * screen and "Last, First" for rosters and reports. Mirrors
 * functions/src/utils/personName.ts; keep the two in step.
 */

export interface NameParts { firstName: string; lastName: string }

export function fullName(firstName?: string | null, lastName?: string | null): string {
  return [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ');
}

/** The last word is the last name; "Reyes, Dana" is turned around; one word is a first name. */
export function splitName(display?: string | null): NameParts {
  const d = (display ?? '').trim().replace(/\s+/g, ' ');
  if (!d) return { firstName: '', lastName: '' };
  const comma = d.indexOf(',');
  if (comma > 0) return { firstName: d.slice(comma + 1).trim(), lastName: d.slice(0, comma).trim() };
  const at = d.lastIndexOf(' ');
  if (at === -1) return { firstName: d, lastName: '' };
  return { firstName: d.slice(0, at), lastName: d.slice(at + 1) };
}

/** "Reyes, Dana"; falls back to whatever is known. */
export function sortName(firstName?: string | null, lastName?: string | null, display?: string | null): string {
  let f = firstName?.trim() ?? '';
  let l = lastName?.trim() ?? '';
  if (!f && !l) ({ firstName: f, lastName: l } = splitName(display));
  if (l && f) return `${l}, ${f}`;
  return l || f;
}
